export interface CanvasMapProps {
  plateNumber: number;
  plateBarcode: string;
  plateRows: number;
  plateColumns: number;
}

export interface GridConfig {
  cellSize: number;
  wellSize: number;
  gap: number;
  startX: number;
  startY: number;
  labelAreaWidth: number;
  labelAreaHeight: number;
  viewportWidth: number;
  viewportHeight: number;
  contentWidth: number;
  contentHeight: number;
}

export interface ContainerSize {
  width: number;
  height: number;
}

export const DEFAULT_GRID_COLUMNS = 12;
export const DEFAULT_GRID_ROWS = 8;
export const GRID_PADDING = 20;
export const WELL_GAP = 5;
export const MIN_CELL_SIZE = 30;
export const SELECTED_WELL_FILL = '#80B4FA';
export const WELL_FILL = 'white';
